<template>
  <div class="invite-bulk">
    <label>Enter Email Addresses</label>
    <textarea
      ref="text"
      @keyup="getEmails"
      placeholder="Please separate email addresses with space, comma or semicolon."
    ></textarea>
  </div>
</template>

<script>
/**
 *  InviteBulk
 * */
export default {
  props: {
    handlers: {
      type: Object,
      required: true,
    },
  },

  data: function () {
    return {
      tempUsers: [],
    };
  },

  activated: function () {
    this.onEmailsChange();
  },

  deactivated: function () {
    // textarea el
    const el = this.$refs.text;
    // reset text
    el.value = '';
    // reset tempUsers
    this.tempUsers = [];
  },

  methods: {
    getEmails: function (event) {
      const emailsRe = /[?,]|[?^;]|(\b\s+\b)/g;
      const value = event.target.value;

      const emails = value
        .split(emailsRe)
        .filter((word) => word && word.trim().length > 0)
        .map((word) => word.trim());

      this.tempUsers = emails.map((email) => {
        const userFromEmail = this.extractUserFromEmail(email);

        const firstName =
          userFromEmail.length === 3
            ? userFromEmail[0] + ' ' + userFromEmail[1]
            : userFromEmail[0];

        const lastName =
          userFromEmail.length === 3
            ? userFromEmail[2]
            : userFromEmail[1] || '';

        return {
          email,
          firstName,
          lastName,
        };
      });

      this.onEmailsChange();
    },

    extractUserFromEmail: function (email) {
      const emailUntilAt = email.match(/[^;@]*/);
      const re = /[[?_]|[?.]/g;
      return emailUntilAt[0].split(re);
    },

    onEmailsChange: function () {
      if (this.handlers.onChangeData) {
        this.handlers.onChangeData('tempUsers', this.tempUsers);
      }
    },
  },
};
</script>
